import { CommonModule } from "@angular/common";
import { Component, Input, OnInit, inject } from "@angular/core";
import { MatTooltipModule } from "@angular/material/tooltip";
import { Cls_MobiDocumentViewer, Cls_MobiFile, FileType } from "../../models";
import { DialogService } from "../../services";

@Component({
    selector: "mobi-office-lib-document-preview",
    templateUrl: "./document-preview.component.html",
    styleUrl: "./document-preview.component.scss",
    imports: [CommonModule, MatTooltipModule]
})
export class DocumentPreviewComponent implements OnInit {
  private readonly dialogService = inject(DialogService);

  readonly FILE_TYPE = FileType;
  private readonly defaultFileType = FileType.IMAGE;

  @Input({ required: true }) item = new Cls_MobiFile();
  @Input({ required: true }) list: Cls_MobiFile[] = [];
  @Input({ required: true }) index: number = 0;

  ngOnInit(): void {
    // setting default type of file to FileType.IMAGE
    this.item.fileType = this.item.fileType || this.defaultFileType;
  }

  onViewDocument() {
    const fileList = this.list?.map((item: any) => {
      const file = new Cls_MobiFile();
      file.fileName = "";
      file.fileSize = 1000;
      file.fileType = item.fileType || this.defaultFileType;
      file.fileUrl = item.fileUrl;
      return file;
    });
    const dialogData = new Cls_MobiDocumentViewer();
    dialogData.FileList = fileList;
    dialogData.selectedFileIndex = this.index;
    this.dialogService.documentViewerDialog(dialogData, () => {});
  }

  // Setting default type to doc if image url not found to load the image
  setDefaultImage(event: Event): void {
    (event.target as HTMLImageElement).src = "global-assets/mobi-office-ui/file-icons/doc.png";
    this.item.fileType = FileType.DOC;
  }
}
